import { StateCreator } from 'zustand';

export type TCardView = 'grid' | 'list';

interface IViewState {
  viewById: Record<string, TCardView>;
}

interface IViewActions {
  setViewById: (id: string, view: TCardView) => void;
}

export interface IViewStore extends IViewState, IViewActions {}

export const createViewSlice: StateCreator<IViewStore> = (set) => ({
  viewById: {},

  setViewById: (id: string, view: TCardView) => {
    set((state) => ({
      viewById: {
        ...state.viewById,
        [id]: view,
      },
    }));
  },
});
